import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDevices,
  toggleDevice,
  exportDevices,
  updateDevicePrefs,
} from "../../services/deviceService";

export const fetchDevicesThunk = createAsyncThunk(
  "devices/fetch",
  async ({ filters = {}, cursor, reset = false }, { rejectWithValue }) => {
    try {
      const params = { ...filters };
      if (cursor) params.cursor = cursor;

      const response = await getDevices(params);
      return {
        devices: response.data.devices,
        nextCursor: response.data.nextCursor,
        hasMore: response.data.hasMore,
        reset,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch devices"
      );
    }
  }
);

export const toggleDeviceThunk = createAsyncThunk(
  "devices/toggle",
  async ({ deviceId, isActive }, { rejectWithValue }) => {
    try {
      const response = await toggleDevice(deviceId, isActive);
      // Extract device from response which has { ok: true, device: {...} } structure
      return response.data.device || response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update device"
      );
    }
  }
);

export const exportDevicesThunk = createAsyncThunk(
  "devices/export",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await exportDevices(filters);

      // Create download link
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `devices_${new Date().toISOString().split("T")[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to export devices"
      );
    }
  }
);

export const updateDevicePrefsThunk = createAsyncThunk(
  "devices/updatePrefs",
  async ({ deviceId, prefs, quietHours }, { rejectWithValue }) => {
    try {
      // Convert quietHours to the preferences format expected by the API
      const prefsPayload = {
        ...prefs,
        ...(quietHours && { quietHours }),
      };

      const response = await updateDevicePrefs(deviceId, prefsPayload);

      return {
        deviceId,
        prefs: response.data.prefs,
        quietHours,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update device preferences"
      );
    }
  }
);
